import React from 'react';
import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  styled,
  Link,
  useTheme,
} from '@mui/material';
import { Profile } from '@par/shared/types/player';
import { avesData } from '@par/shared/components/profile';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    textAlign: 'center',
  },
}));

type PropTypes = {
  viewProfile: Profile;
};

export const Aves = ({ viewProfile }: PropTypes) => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="h5" mb={2}>
        <Link
          href={
            'https://www.scottishgolfhistory.org/origin-of-golf-terms/bogey/'
          }
          target={'_blank'}
          underline="always"
          color={'inherit'}
          sx={{
            textShadow:
              theme.palette.mode === 'dark'
                ? `0 0 0px ${theme.palette.secondary.main}, 0 0 0px ${theme.palette.secondary.main}, 0px 0px 16px ${theme.palette.secondary.main}`
                : 'none',
          }}
        >
          Aves
        </Link>
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small" aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              {avesData(viewProfile).map((item) => (
                <StyledTableCell sx={{ color: item.color }}>
                  {item.name}
                </StyledTableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell>Lifetime</TableCell>
              {avesData(viewProfile).map((item) => (
                <StyledTableCell sx={{ color: item.color }}>
                  {item.lifeTime}
                </StyledTableCell>
              ))}
            </TableRow>
            <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>Per 100 Qs</TableCell>
              {avesData(viewProfile).map((item) => (
                <StyledTableCell sx={{ color: item.color }}>
                  {item.per100Qs}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
